<s1-input-select [control]="control" [itemsList]="valori" [label]="label" [multiple]="multiple"></s1-input-select>